<template>
    <section v-if="config?.banners != null && config?.banners.length > 0" class="c-startpage-teaser-banner flex flex-col gap-4">
        <div v-for="entry in config?.banners" :key="entry.title">
            <NuxtLink v-if="entry.title" :to="entry.url" :external="true" class="item">
                <img class="lg:hidden rounded-3xl" :src="entry.mobileImg.url" :alt="entry.mobileImg.altText ?? entry.altText ?? entry.title">
                <img class="hidden lg:block rounded-3xl" :src="entry.desktopImg.url" :alt="entry.desktopImg.altText ?? entry.altText ?? entry.title">
            </NuxtLink>
        </div>
    </section>
</template>
<script setup lang="ts">
  interface StartpageConfig {
    layout?: string;
    banners?: Banners[];
  }
  interface Banners {
    title: string;
    altText: string;
    mobileImg: { url:string, altText?:string };
    desktopImg: { url:string, altText?:string };
    url: string;
  }
  
  const config = inject("startpageConfig") as Ref<StartpageConfig> | undefined;
</script>
<style scoped lang="postcss">
.item {
  @apply flex flex-col justify-between h-full;
}
</style>
